import React from 'react';
import { string, func, object, oneOf } from 'prop-types';
import classnames from 'classnames/bind';
import { renderButtons } from '../../common';

import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import Illustration from 'foundations/Illustrations/Illustration';

import styles from './HotspotSelfcareB.css';

const cx = classnames.bind(styles);

const HotspotSelfcareB = ({
  title,
  description,
  highlighted,
  button,
  link,
  onClick,
  colorScheme,
  withIllustration
}) => {
  const buttons = [
    {
      onClick,
      class: classnames(
        'secondary',
        'small',
        styles.link,
        {
          'black': colorScheme === 'lb01' || colorScheme === 'db02',
          'white': colorScheme === 'db01'
        }
      ),
      text: button,
      maxWidth: 1024
    },
    {
      onClick,
      class: classnames(
        'secondary',
        styles.link,
        {
          'black': colorScheme === 'lb01' || colorScheme === 'db02',
          'white': colorScheme === 'db01'
        }
      ),
      text: button,
      minWidth: 1025
    }
  ];

  try {
    if (button && link) {
      throw Error ('HotspotSelfcareB is composed by either button or link, not both.');
    }

    if (!button && !link) {
      throw Error ('A button or link is required.');
    }
  }

  catch (err) {
    console.warn(err);
    return null;
  }
  return (
    <div className={classnames(colorScheme, styles.wrapper)}>
      <div className={styles.container}>
        <Illustration name={withIllustration.name} size={withIllustration.size} customClasses={styles.illustration} />

        <h1 className={'section-title ' + cx('title', { 'v2': link })}>
          {highlighted && <span className={styles.highlight}>{highlighted}<br/></span>}
          {title}
        </h1>

        {
          description && <p className={'p ' + cx('description', { 'v2': link })}>
              {description}
            </p>
        }

        { button && renderButtons(buttons) }

        {
          link &&
            <LinkFreeStanding
              className={styles.link}
              medium={colorScheme === 'lb01' || colorScheme === 'db02'}
              dark={colorScheme === 'db01'}
              size="m"
              icon={{
                direction: 'right',
                name: 'arrow-right',
                type: '20'
              }}
              onClick={onClick}  
              withBouncing
            >
              {link}
            </LinkFreeStanding>
        }
      </div>
    </div>
  );
};

HotspotSelfcareB.propTypes = {
  button: string,
  colorScheme: oneOf([
    'lb01',
    'db01',
    'db02',
  ]),
  description: string,
  highlighted: string,
  link: string,
  onClick: func,
  title: string.isRequired,
  withIllustration: object
};

HotspotSelfcareB.defaultProps = {
  colorScheme: 'lb01'
};

HotspotSelfcareB.displayName = 'HotspotSelfcareB';

export default HotspotSelfcareB;



// WEBPACK FOOTER //
// ./src/uis/components/Hotspots/Selfcare/HotspotB/HotspotSelfcareB.js